import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../../styles/breakPoints'
import SearchInput from '../../atoms/searchInput'
import SearchSvg from '../../atoms/searchSvg'

const Wrapper = styled.nav`
  display: none;

  ${BreakPoints.large} {
    display: block;

    .p-nav-area {
      display: flex;
      align-items: center;
      padding: 5px 0 0;
      position: fixed;
      right: 50px;

      .nav-search {
        display: none;
      }
    }

    .p-nav-area {
      #nav-content {
        display: contents;
        position: relative;
        padding: 50px 0 20px;
      }

      #nav-open {
        width: 34px;
        height: 34px;
        vertical-align: middle;
        cursor: pointer;

        display: flex;
        justify-content: center;
        padding-top: 7px;
      }

      #nav-open span {
        display: block;
        width: 30px;

        svg {
          position: relative;
          top: -5px;
        }
      }

      #nav-open span:before,
      #nav-open span:after {
        position: absolute;
        height: 3px; /*線の太さ*/
        width: 25px; /*長さ*/
        border-radius: 3px;
        background: #3ec7b3;
        display: block;
        content: '';
        z-index: 10000;
        transition: 0.1s;
        opacity: 0;
      }

      #nav-open span:before {
        display: none;
        transition: 0.1s ease-in-out;
      }

      #nav-open span:after {
        display: none;
        transition: 0.1s ease-in-out;
      }

      /*閉じる用の薄黒箇所*/

      #nav-close {
        display: none;
        position: fixed;
        z-index: 99;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: black;
        opacity: 0;
        transition: 0.1s ease-in-out;
      }

      /*メニューの中身*/

      #nav-content {
        display: block;
        overflow: auto;
        position: fixed;
        top: 0;
        z-index: -1;
        visibility: hidden;

        * {
          opacity: 0;
        }

        .search-input-wrap {
          transform: scale(1.25);
          position: fixed;
          top: 70px;
          bottom: unset;
          width: 350px;
          left: calc(50% - (350px / 2));
          box-shadow: 0 0 5px rgba(0, 0, 0.6);
          border-radius: 8px;
          transition: 0s;
        }
      }

      #nav-search:checked {
        + #nav-open {
          border: solid 1px #e0e0e0;
          background: white;
          position: relative;
          z-index: 10002;
          border-radius: 100vh;
        }

        + #nav-open span {
          width: 0;
        }

        + #nav-open span:before {
          width: 25px;
          transform-origin: 50% 50%;
          transform: rotate(45deg) translate(-20%, 325%);
          left: 14px;
          top: 11px;
          opacity: 1;
          display: block;
        }

        + #nav-open span:after {
          width: 25px;
          transform-origin: 50% 50%;
          transform: rotate(-45deg) translate(-20%, 325%);
          top: 4px;
          left: 0;
          display: block;
          opacity: 1;
        }
      }

      /*チェックがついたら表示させる*/

      #nav-search:checked ~ #nav-close {
        display: block;
        opacity: 0.7;
      }

      #nav-search:checked ~ #nav-content {
        z-index: 10001;
        box-shadow: 6px 0 25px rgba(0, 0, 0, 0.5);
        visibility: visible;
        display: contents;

        * {
          opacity: 1;
          z-index: 10001;
        }
      }
    }
  }
`

/**
 * ヘルプスマホ用検索窓
 * @constructor
 */
const HelpSpSearch = (): JSX.Element => (
  <Wrapper className="nav-search">
    <div className="p-head-inner">
      <nav className="p-nav-area ">
        <input id="nav-search" type="checkbox" className="nav-search" />
        <label id="nav-open" htmlFor="nav-search">
          <span>
            <SearchSvg />
          </span>
        </label>
        <label className="nav-search" id="nav-close" htmlFor="nav-search">
          <span />
        </label>
        <div id="nav-content">
          <SearchInput />
        </div>
      </nav>
    </div>
  </Wrapper>
)

export default HelpSpSearch
